import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter } from 'angular-calendar';
import moment, { Moment } from 'moment';
import { TabConst } from 'src/app/tabms/tab-consts';

// import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
// import { FormControl } from '@angular/forms';
// import { Moment } from 'moment';
// import moment from 'moment';
// import { MatDatepicker } from '@angular/material/datepicker';
// import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

//formate date mm/yyyy
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-mm-yy-date-picker',
  templateUrl: './mm-yy-date-picker.component.html',
  styleUrl: './mm-yy-date-picker.component.scss',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class MmYyDatePickerComponent implements OnChanges {
  @Input() dateCustom: string
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE // New input for size control

  // Initialize form control with null so the input can safely start blank
  date: FormControl<Moment | null> = new FormControl<Moment | null>(null);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dateCustom']) {
      if (this.dateCustom) {
        this.date.setValue(moment(this.dateCustom, 'YYYY-MM'));
      } else {
        this.date.setValue(null);
      }
    }
  }

  @Output() selectedDate = new EventEmitter<string>();
  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>,) {
    // Ensure we have a valid base moment even if initial value was empty
    let base = this.date?.value as Moment | null;
    if (!base || !moment.isMoment(base) || !base.isValid()) {
      base = moment();
    }
    const ctrlValue = base.clone();
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.selectedDate.emit(ctrlValue.format('MM/YYYY'));
  }
}
